export default __webpack_public_path__ + "static/Campaign-8dd14799ccd54d589c1fb8d9d3926910.svg";